import { API } from "../../constants/APIConstants";
import { callAPI } from "../../config/AxiosTemplate";

export const getPromotionDetailsAction = (promotionId, callback) => {
  callAPI(
    "getPromotionDetailsAction",
    API.getPromotionDetails + "" + promotionId,
    "GET",
    {},
    (apiResponse) => {
      callback(apiResponse);
    }
  );
};

export const updateAnalysisPromotionStatusAction = (
  request,
  callback
) => {
  callAPI(
    "updateAnalysisPromotionStatusAction",
    API.updateAnalysisPromotionStatus,
    "POST",
    request,
    (apiResponse) => {
      callback(apiResponse);
    }
  );
};
